import React from "react";
import connect from "Shared/connect";
import Flyout from "Shared/Flyout";
import Icon from "Shared/Icon";
import * as styles from "./base.scss";
import ProductsSlider from "./Menus/ProductsSlider";
import LoginMenuRow from "./Menus/LoginMenuRow";
import Slider from "./Slider";
import { translate } from "Shared/translate";
import LoginSlider from "./Menus/LoginSlider";
import { logout } from "../../Account/action-creators";
import MyMenigoIcon from "../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
import classnames from "classnames";
import Button from "Shared/Button";
const InitialState = {
    animation: "forward",
    headline: null,
    prev: null,
    current: null,
};
class Sliding extends React.Component {
    constructor(props) {
        super(props);
        this.back = () => {
            this.setState({ animation: "back", current: null }, () => {
                document.getElementById("MobileMenu").scrollTo(0, 0);
            });
        };
        this.forward = (headline, element, props = {}) => this.setState({
            animation: "forward",
            current: { element, props },
            headline,
        });
        this.reset = () => this.setState(InitialState);
        this.getMenuItems = () => {
            const menuItems = this.props.mainMenu.primaryMenuItems.concat(this.props.mainMenu.rightContentLinks);
            return menuItems;
        };
        this.logOut = () => {
            this.props.currentUser.isImpersonating
                ? this.props.logout()
                : (window.location.href = "/Logout/OktaLogout");
        };
        this.state = InitialState;
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.props.mainMenuIsOpen && !newProps.mainMenuIsOpen) {
            this.reset();
        }
        document.getElementById("MobileMenu").scrollTo(0, 0);
    }
    render() {
        return (React.createElement(Flyout, { position: "right", toggleFlyout: this.props.toggleMainMenu, isOpen: this.props.mainMenuIsOpen, canOpen: this.props.canOpen, fillWidth: true },
            React.createElement("div", { id: "MobileMenu", className: classnames(styles.base, !!this.props.isLoggedIn && styles.loggedIn) },
                React.createElement("div", { className: styles.header },
                    (this.state.current && (React.createElement("a", { onClick: this.back },
                        React.createElement(MyMenigoIcon, { name: "arrow" }),
                        this.state.headline))) || React.createElement("span", null, translate("/SiteLayout/Header/Brand")),
                    React.createElement("a", { className: styles.close, onClick: this.props.toggleMainMenu },
                        React.createElement(Icon, { name: "close" }))),
                React.createElement(Slider, { direction: this.state.animation },
                    React.createElement("div", { key: "MainMenu" }, this.state.current == null ? (React.createElement(React.Fragment, null,
                        React.createElement(ProductsSlider, { displayName: translate("/Product/Product"), children: this.getMenuItems() }),
                        !!!this.props.isLoggedIn &&
                            this.props.mainMenu.topContentLinks.map((item) => {
                                return (React.createElement("a", { key: item.url, href: item.url },
                                    React.createElement("div", { id: "myMenigoTest1", className: classnames(styles.primary, styles.topLinks) },
                                        React.createElement("span", null, item.displayName),
                                        React.createElement(MyMenigoIcon, { name: "arrow" }))));
                            }),
                        this.props.isLoggedIn && (React.createElement("a", { id: "myMenigoTest2", className: classnames(styles.myMenigo), onClick: () => this.forward(translate("/MyMenigo/Header/MyMenigo"), LoginSlider) },
                            React.createElement("div", { className: styles.primary },
                                React.createElement("span", null,
                                    React.createElement(MyMenigoIcon, { name: "user" }),
                                    translate("/MyMenigo/Header/MyMenigo")),
                                React.createElement(MyMenigoIcon, { name: "arrow" })))))) : (React.createElement(this.state.current.element, this.state.current.props)))),
                !!this.props.isLoggedIn ? (React.createElement("div", { className: classnames(styles.userInfoWrapper, styles.myMenigo) },
                    !this.props.isSupplierSalesman ? (React.createElement("div", null,
                        React.createElement("span", { className: styles.userInfoLabel, "data-ta": "logged-in-customer-label" }, this.props.currentUser.punchOutSessionActive
                            ? translate("/SiteLayout/Header/LoggedAsPunchOut")
                            : translate("/SiteLayout/Header/LoggedAsCustomer")),
                        React.createElement("span", { className: styles.userInfoItem },
                            this.props.currentUser.customerId,
                            ",",
                            " "),
                        React.createElement("span", { className: styles.userInfoItem }, this.props.currentUser.companyName),
                        this.props.currentUser.fullName !=
                            this.props.currentUser.companyName && (React.createElement("span", { className: styles.userInfoItem },
                            ", ",
                            this.props.currentUser.fullName)),
                        !!this.props.currentUser.orderReferenceId && (React.createElement(React.Fragment, null,
                            React.createElement("span", { className: styles.userInfoLabel },
                                translate("/MyMenigo/CustomerProfileBlock/OrderReferenceId"),
                                ":"),
                            React.createElement("span", { className: styles.userInfoItem }, this.props.currentUser.orderReferenceId))))) : (React.createElement("div", { className: classnames(styles.suppliersalesmanWrapper, styles.myMenigo) },
                        React.createElement("span", { className: styles.userInfoLabel }, translate("/SiteLayout/Header/LoggedAsSupplierSalesman")),
                        React.createElement("span", { className: styles.userInfoItem }, this.props.suppliersalesmanInfo),
                        React.createElement("span", { className: styles.suppliersalesmanInfo },
                            React.createElement("span", { className: styles.userInfoLabel }, translate("/SiteLayout/Header/ChosenCustomer")),
                            React.createElement("span", { className: styles.userInfoItem },
                                this.props.currentUser.customerId,
                                ",",
                                " "),
                            React.createElement("span", { className: styles.userInfoItem }, this.props.currentUser.companyName),
                            this.props.currentUser.fullName !=
                                this.props.currentUser.companyName && (React.createElement("span", { className: styles.userInfoItem },
                                ", ",
                                this.props.currentUser.fullName)),
                            this.props.activeExhibition && (React.createElement("span", { className: styles.suppliersalesmanExhibition },
                                React.createElement("span", { className: styles.userInfoLabel }, translate("/SiteLayout/Header/Exhibition")),
                                React.createElement("span", null, this.props.activeExhibition)))))),
                    React.createElement(Button, { appearance: "bare", className: classnames(styles.myMenigoButton), onClick: () => this.logOut() }, translate("/Account/MyPages/Logout")))) : (React.createElement(LoginMenuRow, null)),
                React.createElement("div", null))));
    }
}
export default connect((state) => ({
    isLoggedIn: !!state.currentUser && state.currentUser.isLoggedIn,
    selectedLanguage: state.appShellData.languageSites.find((lng) => lng.language === state.currentUser.userSettings.selectedLanguageCode),
    mainMenu: state.appShellData.mainMenu,
    mainMenuIsOpen: state.mainMenu.isOpen,
    currentUser: state.currentUser,
    isSupplierSalesman: state.currentUser.isSupplierSalesman,
    suppliersalesmanInfo: state.currentUser.supplierSalesmanInfo,
    activeExhibition: state.currentUser.activeExhibition,
}), (dispatch) => ({
    logout: () => dispatch(logout()),
}))(Sliding);
